import { ol_Feature, ol_style } from "@omnia/exports/openlayers"
import { getFeaturePoints } from "../utils"

export const red = [220, 20, 60]
export const accent = [0x06, 0x79, 0xca]
export const olblue = [0, 153, 255, 1]

type Color = string | number[]

export function getSelectedStrokeStyle(innerColor: Color = red, zIndex: number = undefined): { inner: ol_style.Style, outer: ol_style.Style } {

    const selectedWidth = 3

    const selectedStrokeOuter = new ol_style.Style({
        stroke: getStroke(selectedWidth + 2, [255, 255, 255, 1]),
        zIndex
    });

    const selectedStrokeInner = new ol_style.Style({
        stroke: getStroke(selectedWidth, innerColor),
        zIndex
    });

    return {
        outer: selectedStrokeOuter,
        inner: selectedStrokeInner,
    }
}

export function getSelectedStyle(innerColor: Color = red): ol_style.Style[] {
    const { inner, outer } = getSelectedStrokeStyle(innerColor)
    return [outer, inner]
}

export function getDefaultEditStylePoint(fillColor?: number[], strokeColor?: number[], zIndex: number = Infinity): ol_style.Style[] {

    strokeColor = strokeColor || [255, 255, 255, 1];
    fillColor = fillColor || olblue
    var width = 3;

    return [
        new ol_style.Style({
            image: new ol_style.Circle({
                radius: width * 2,
                fill: new ol_style.Fill({
                    color: fillColor
                }),
                stroke: getStroke(width / 2, strokeColor)
            }),
            zIndex
        })
    ];

}

export function getBaseEditStyle(fillColor: any, strokeWidth: number = 3, strokeColor?: any): ol_style.Style[] {

    const styles = [

        strokeWidth > 0
            ? getStrokeStyle(strokeWidth + 2, [255, 255, 255, 1], 999)
            : undefined,

        new ol_style.Style({
            stroke: getStroke(strokeWidth, strokeColor || olblue),
            fill: (fillColor ? new ol_style.Fill({ color: fillColor }) : null),
            zIndex: 999,
        })

    ];

    return styles.filter(s => !!s)

}

export function getDefaultEditStyleFunction(feature: ol_Feature, fillColor: any = [255, 255, 255, 0.5], showPoints: boolean = true, textStylesProvider?: ((resolution, zIndex) => ol_style.Style[]), strokeColor?: any, stroke: boolean = true): (feature: ol_Feature, resolution: number) => ol_style.Style[] {

    if (feature) {

        let geom = <any>feature.getGeometry();

        switch (geom.getType()) {

            case "Point":
                showPoints = false;
                break;

        }
    }

    return (_: ol_Feature, resolution: number) => {

        let styles = getBaseEditStyle(fillColor, (stroke ? 3 : 0), strokeColor)

        if (showPoints) {
            styles.push(getFeaturePointStyle(feature))
        }

        if (textStylesProvider) {

            const textStyles = textStylesProvider(resolution, 1000)

            if (textStyles) {

                for (const ts of textStyles) {

                    const clone = new ol_style.Style({
                        text: ts.getText(),
                        geometry: ts.getGeometry() || ts.getGeometryFunction(),
                        zIndex: 1000
                    })

                    styles = styles.concat(clone)

                }
            }

        }

        return styles;

    }

}

export function getFeaturePointStyle(feature: ol_Feature) {

    return new ol_style.Style({

        image: new ol_style.Circle({
            radius: 4,
            fill: new ol_style.Fill({
                color: '#fff'
            }),
            stroke: getStroke(1, '#000')
        }),

        zIndex: 999,

        geometry: getFeaturePoints(feature, true),

    })

}

export function getStrokeStyle(width: number, color: string | number[], zIndex?: number) {

    const stroke = getStroke(width, color)

    return stroke
        ? new ol_style.Style({ stroke, zIndex })
        : undefined

}

export function getStroke(width: number, color: string | number[]) {

    if (!width) return undefined

    return new ol_style.Stroke({
        width,
        color
    })

}
